import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import {  getFilterAttributes,  exportPdf,  getInputType,  getFilterLable,} from 'src/app/app.utils';

@Component({
  selector: 'app-usecase-base',
  templateUrl: './usecase-base.component.html',
  styleUrls: ['./usecase-base.component.css'],
})

/**
 * Exetended by usecase component / uiform components to avoid duplication
 */
export class UsecaseBaseComponent extends BaseListCtl {
  getInputType = getInputType;
  getFilterAttributes = getFilterAttributes;
  getFilterLable = getFilterLable;

  @Input() appId: number = 0;
  @Input() usecaseId: number | null = 0;
  @Input() id: number | null = 0;
  @Input() usecase: any;
  @Input() usecaseAttributes: any = [];
  @Input() parentUsecaseList: any = [];
  @Input() usecaseData = [];
  @Input() isUserFilter: number = 0;
  public formListRecord: number = 0;

  searchValues: any = {};

  //flag use for toggle Search
  showSearchInputs = false;

  public apiurl: string = '';

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;

    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  override ngOnInit() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        if (_self.usecaseId) {
          _self.getUsecaseSchema();
        }
      });
  }

  public async getUsecaseSchema(getdata: boolean = true, callback?: any) {
    let _self = this;
    _self.getUsecase(getdata, (property: string) => {
      if (callback) {
        callback();
      }
    });
  }

  // get usecase scema
  public getUsecase(getdata: boolean = true, callback?: any) {
    let _self = this;
    let url =
      _self.locator.config.get('endpoint.userstory') +
      '/get/' +
      _self.usecaseId;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecase = res.result.data;
      if (_self.appId === 0) {
        _self.appId = _self.usecase['appId'];
      }
       let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');
      _self.apiurl =
        _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
      _self.getUsecasePreloadData();
      _self.getUsecaseAttribute(getdata, callback);
    });
  }

  /**
   * Get usecase preload data
   */
  public getUsecasePreloadData() {
    let _self = this;
    let url = _self.apiurl + '/preload';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form['preload'] = res.result;
    });
  }

/**  public getUsecaseAttribute(getdata: boolean = true, callback?: any) {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      _self.usecaseId;
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecaseAttributes = res.result.data;
      if (_self.usecaseAttributes?.length > 0) {
        _self.usecaseAttributes.forEach((attribute: any) => {
          const matchingField = _self.form.data['fields'].find(
            (field: any) => field.id === attribute.id
          );
          if (matchingField) {
            attribute.label = matchingField.label;
            attribute.listView = matchingField?.listView;
          }
        });
      }
      _self.afterUsecaseAttrGet();
      if (getdata) {
        _self.getUsecaseDataList(callback);
      } else if (callback) {
        callback();
      }
    });
  } */

  public getUsecaseAttribute(getdata: boolean = true, callback?: any) {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      _self.usecaseId;
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.usecaseAttributes = res.result.data;
      if (
        _self.usecaseAttributes?.length > 0 &&
        Array.isArray(_self.form?.data?.fields)
      ) {
        _self.usecaseAttributes.forEach((attribute: any) => {
          const matchingField = _self.form.data.fields.find(
            (field: any) => field.id === attribute.id
          );
          if (matchingField) {
            attribute.label = matchingField.label;
            attribute.listView = matchingField?.listView;
          }
          const conditionMet = _self.usecaseAttributes.some(
            (e: any) => e.depAttribute === attribute['code']
          );
          if (conditionMet) {
            let depAttribute = attribute;
            _self.parentUsecaseList.push(depAttribute);
          }
        });
      } else {
        console.warn('fields is undefined or not an array', _self.form?.data);
      }

      _self.afterUsecaseAttrGet();
      if (getdata) {
        _self.getUsecaseDataList(callback);
      } else if (callback) {
        callback();
      }
    });
  }
public getSearchCriteria() {
  let searchdata = Object.fromEntries(
    Object.entries(this.searchValues).filter(
      ([_, value]) =>
          value != undefined &&
          value != 'undefined' &&
        value !== null &&
          !Number.isNaN(value) &&
        value !== ''
    )
  );

  Object.keys(searchdata).forEach((key) => {
    let value = searchdata[key];
    const attr = this.usecaseAttributes.find((a: any) => a.code === key);
    if (attr) {
      if (attr.type === 'list') {
        searchdata[key] = String(value);
      }else if (attr.type === 'dateandtime') {      
        try {
          const utcIso = new Date(value as string).toISOString();
          searchdata[key] = utcIso;
        } catch (err) {
          console.warn('Invalid datetime for search:', value);
        }
      } 
       else if (attr.type === 'idate') {
          try {
            const utcIso = new Date(value as string).toISOString();
            searchdata[key] = utcIso;
          } catch (err) {
            console.warn('Invalid date for search:', value);
          }
        }
  
       else if (attr.type === 'itime') {
            try {
              const valStr = String(value);        
              // if input format is HH:mm
              if (valStr.length === 5) {
                value = `1970-01-01T${valStr}:00`;
              }        
              searchdata[key] = new Date(value as string).toISOString();
            } catch {
              console.warn("Invalid time:", value);
        }
      } else if (attr.type === 'email') {
        searchdata[key] = String(value).trim();
      } else if (attr.type === 'text' || attr.type === 'textarea') {
        searchdata[key] = String(value).trim();
      } else {
        if (typeof value === 'string' && value.trim() !== '') {
          const isNumeric = /^-?\d+(\.\d+)?$/.test(value);
          if (isNumeric) {
            searchdata[key] = Number(value);
          }
        }
      }
    }
  });

  searchdata = this.setSearchData(searchdata);
  return searchdata;
}

  public getUsecaseDataList(callback?: any) {
    let _self = this;
    let url = _self.apiurl + '/search';
    if (_self.is_paging) {
      url = _self.apiurl + '/search/' + _self.form.pageNo;
    }

    if (_self.isUserFilter == 1) {
      const keySuffix = localStorage.getItem('keySuffix');
      const loginId = localStorage.getItem(keySuffix + 'loginId');
      _self.searchValues['createdBy'] = loginId;
    } else {
      delete _self.searchValues['createdBy'];
    }

    _self.locator.http.post(
      url,
      _self.getSearchCriteria(),
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.usecaseData = res.result['data'];
        _self.formListRecord = res.result.recordCount; 
        _self.form.pageCount = res.result.pageCount;
        _self.form.pageSize = res.result.pageSize;
        _self.form.pageNos = _self.form.pageNo;
        _self.form.pageNoList = [];
        for (let i = 0; i < _self.form.pageCount; i++) {
          _self.form.pageNoList.push(i);
        }
        if (_self.usecaseData.length == 0) {
          _self.form.message = 'No record found';
          _self.form.error = true;
        }
        if (callback) {
          callback();
        }
        _self.processData();
      }
    );
  }

  afterUsecaseAttrGet() {}

  processData() {}
  /**
   * Download PDF HTML
   */
  downloadPDF() {
    let _self = this;
    exportPdf(_self, _self.usecase['collectionName']);
  }

  toggleSearchInputs() {
    this.showSearchInputs = !this.showSearchInputs;
    this.searchValues = {};
  }

  onSearchValueChange(e: any, value: string) {
    this.searchValues[e.code] = e.type === 'number' ? parseFloat(value) : value;    
  }

  onSearchReferenceValueChange(e: any, value: string) {
    this.searchValues[e.code] = parseFloat(value);
  }

  objectEntries(obj: Record<string, any>): [string, any][] {
    return Object.entries(obj);
  }

  urlRewrite(endpoint: string) {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let sid = localStorage.getItem(keySuffix + 'sessionId');
    if (!sid) {
      sid = '0';
    }
    endpoint = endpoint + ';jsessionid=' + sid;
    return endpoint;
  }

  public getString(val: any, type: string) {
    if (val) {
      if (type === 'object') {
        val = JSON.stringify(val);
      }
      if (type === 'dateandtime') {
         try {          
        const utcDate = new Date(val);
        const d = new Date(utcDate);
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const day = d.getDate().toString().padStart(2, "0");
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const localISO = `${year}-${month}-${day} ${hours}:${minutes}`;
          return localISO;
        
        } catch (err) {
           return val;
        }
      }
      if (type === 'idate') {
        try {
          const utcDate = new Date(val);
          const d = new Date(utcDate);
          const year = d.getFullYear();
          const month = (d.getMonth() + 1).toString().padStart(2, '0');
          const day = d.getDate().toString().padStart(2, '0');
          const hours = d.getHours().toString().padStart(2, '0');
          const minutes = d.getMinutes().toString().padStart(2, '0');
          const localISO = `${year}-${month}-${day}`;
          return localISO;
        } catch (err) {
          return val;
        }
      }
      if (type == 'time') {
        const d = new Date(val);
        const hh = d.getHours().toString().padStart(2, "0");
        const mm = d.getMinutes().toString().padStart(2, "0");
        const localISO = `${hh}:${mm}`;
        return localISO;

      }
      return val;
    } else {
      return '';
    }
  }

  /**
   * Get API base URL
   * @returns
   */
  getAPIBaseUrl(suburl?: string) {
    let _self = this;
    let updatedName = _self.usecase['collectionName'].replace(/\./g, '/');
    let url = _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    if (suburl) {
      url += '/' + suburl;
    }
    return url;
  }
}
